import { render, staticRenderFns } from "./AutoPositivo.vue?vue&type=template&id=05d1f520&"
import script from "./AutoPositivo.vue?vue&type=script&lang=js&"
export * from "./AutoPositivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports